// extracted by mini-css-extract-plugin
module.exports = {"contentPage":"Content_contentPage__1YOYG","title":"Content_title__GgqTP","pagination":"Content_pagination__2azd0"};